import React from "react";
import "../../styles/Tag.css";

const Tag = (props) => {
    return(
        <div className="tag" style={{borderColor: props.color, color: props.color, '--neon-color': props.color}}>
            <p>{props.text}</p>
        </div>
    );
}

export default Tag;